// extracted by mini-css-extract-plugin
export default {"optionsTitle":"optionsTitle___SxJwY","optionsContainer":"optionsContainer___uA_LS"};